import { styled as d, ThemeProvider as y, GlobalStyles as f, toggleButtonClasses as i, alpha as l } from "@mui/material";
export * from "@mui/material";
import { jsx as c, jsxs as b } from "react/jsx-runtime";
import { IgsBrandColor as n, IgsEnvironmentColor as a } from "@igs/react";
import { createTheme as k } from "@mui/material/styles";
const C = (t) => t === "horizontal" ? "column" : "row", H = d("div")(({ theme: t, spacing: e, orientation: r, fullWidth: o }) => ({
  alignItems: "center",
  display: o ? "grid" : "inline-grid",
  gap: typeof e == "string" ? e : t.spacing(e),
  gridAutoFlow: C(r),
  justifyItems: o ? "stretch" : "start"
})), S = ["ownerState", "theme", "innerRef", "as", "forwardedAs", "sx", "css", "theme", "ref"], u = (t) => !t.startsWith("$") && !S.includes(t), g = {
  shouldForwardProp: u
}, q = (t) => ({
  shouldForwardProp: (e) => {
    const r = typeof t == "string" ? t === e : t.some((o) => o === e);
    return !u(e) && !r;
  }
}), A = {
  active: (t) => t.palette.secondary.dark,
  open: (t) => t.palette.grey[300],
  complete: (t) => t.palette.secondary.main
}, v = d("span", g)`
  display: flex;
  flex-direction: ${({ $direction: t }) => t === "vertical" ? "column" : "row"};
`, D = d("span", g)`
  background-color: ${({ theme: t, $status: e }) => A[e](t)};
  border-radius: ${({ $size: t }) => t};
  display: inline-block;
  height: ${({ $size: t }) => t};
  margin: 2px;
  width: ${({ $size: t }) => t};
`, E = (t, e) => t < e ? "complete" : t === e ? "active" : "open", Q = ({
  steps: t,
  currentStep: e,
  size: r = "8px",
  direction: o = "horizontal",
  ...m
}) => {
  const F = t.indexOf(e);
  return /* @__PURE__ */ c(v, { $direction: o, ...m, children: t.map((h, p) => /* @__PURE__ */ c(D, { $size: r, $status: E(p, F), title: h }, p)) });
}, s = k(), x = {
  ...s.palette,
  background: {
    default: "#FAFAFA",
    paper: "#FFFFFF"
  },
  primary: {
    main: "#1976D2",
    dark: "#0D47A1",
    light: "#42A5F5",
    contrastText: "#FFF",
    content: "#142F51",
    background: "#E9F1F9"
  },
  secondary: {
    main: "#00ACC1",
    dark: "#006064",
    light: "#26C6DA",
    contrastText: "#FFF",
    content: "#1A444C",
    background: "#E8F6F8"
  },
  error: {
    main: "#D32F2F",
    dark: "#C62828",
    light: "#EF5350",
    contrastText: "#FFF",
    content: "#541313",
    background: "#FBEAEA"
  },
  warning: {
    main: "#ED6C02",
    dark: "#E65100",
    light: "#FF9800",
    contrastText: "#FFF",
    content: "#5F2B01",
    background: "#FDF0E6"
  },
  info: {
    main: "#0288D1",
    dark: "#01579B",
    light: "#03A9F4",
    contrastText: "#FFF",
    content: "#013654",
    background: "#E6F3FA"
  },
  success: {
    main: "#2E7D32",
    dark: "#1B5E20",
    light: "#4CAF50",
    contrastText: "#FFF",
    content: "#123214",
    background: "#EAF2EA"
  },
  grey: {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
    A100: "#f5f5f5",
    A200: "#eeeeee",
    A400: "#bdbdbd",
    A700: "#616161"
  },
  common: {
    black: "#000",
    white: "#FFF"
  }
}, G = {
  igsBlue: n.IgsBlue,
  igsGreen: n.IgsGreen,
  washedCotton: n.WashedCotton,
  skyGradientStart: n.SkyGradientStart,
  skyGradientMiddle: n.SkyGradientMiddle,
  skyGradientEnd: n.SkyGradientEnd,
  deepSea: n.DeepSea,
  sunshine: n.Sunshine,
  robinsEgg: n.RobinsEgg,
  sunsetSky: n.SunsetSky,
  freshGrass: n.FreshGrass,
  rustOrange: n.RustOrange,
  spruce: n.Spruce,
  carbonNeutral: n.CarbonNeutral
}, T = {
  local: a.Local,
  trn: a.Trn,
  dev: a.Dev,
  int: a.Int,
  qa: a.Qa,
  prod: a.Prod,
  con1: a.Con1,
  con2: a.Con2,
  con3: a.Con3,
  con4: a.Con4
}, $ = ["primary", "secondary", "error", "warning", "info", "success"], w = ["error", "warning", "info", "success"], M = () => {
  var t, e;
  return {
    ...s,
    igs: {
      brand: G,
      environment: T
    },
    palette: x,
    components: {
      ...s.components,
      MuiAlert: {
        ...((t = s.components) == null ? void 0 : t.MuiAlert) ?? {},
        defaultProps: {
          variant: "filled"
        },
        variants: w.map((r) => ({
          props: { variant: "soft", color: r },
          style: ({ theme: o }) => ({
            backgroundColor: o.palette[r].background,
            color: o.palette[r].content
          })
        }))
      },
      MuiChip: {
        ...((e = s.components) == null ? void 0 : e.MuiChip) ?? {},
        variants: $.map((r) => ({
          props: { variant: "soft", color: r },
          style: ({ theme: o }) => ({
            backgroundColor: o.palette[r].background,
            color: o.palette[r].content
          })
        }))
      },
      MuiMenuItem: {
        defaultProps: {
          dense: !0
        }
      }
    },
    typography: {
      ...s.typography,
      fontFamily: 'Roboto, "Gotham SSm A", "Gotham SSm B", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontSize: 16,
      fontWeightBold: 800,
      fontWeightLight: 300,
      fontWeightMedium: 500,
      fontWeightRegular: 400,
      htmlFontSize: 16,
      button: {
        ...s.typography.button,
        textTransform: "capitalize"
      }
    }
  };
}, P = M(), B = (t) => ({
  [`&.${i.root}`]: {
    [`&.${i.selected}`]: {
      backgroundColor: `${l(t.palette.primary.main, 0.12)} !important`,
      color: `${t.palette.primary.dark} !important`
    },
    [`&:not(.${i.selected})`]: {
      color: `${t.palette.primary.main} !important`,
      ":hover": {
        backgroundColor: `${l(t.palette.primary.main, 0.06)} !important`
      }
    },
    border: `1px solid ${l(t.palette.primary.main, 0.5)} !important`
  }
}), I = (t) => ({
  ".MuiDataGrid-cell": {
    display: "flex",
    alignItems: "center"
  },
  ".MuiDataGrid-virtualScroller": {
    borderTopColor: t.palette.grey[300],
    zIndex: 1e3
  },
  ".MuiDataGrid-root": {
    borderRadius: "0 !important",
    border: 0
  }
}), z = () => ({
  html: {
    height: "100vh"
  },
  body: {
    height: "100%"
  }
}), O = (t) => {
  const e = B(t), r = I(t), o = z();
  return {
    ...e,
    ...r,
    ...o
  };
}, J = ({ theme: t, children: e }) => {
  const r = t ?? P;
  return /* @__PURE__ */ b(y, { theme: r, children: [
    /* @__PURE__ */ c(f, { styles: O(r) }),
    e
  ] });
};
export {
  Q as DotProgress,
  v as DotProgressContainer,
  D as DotProgressDot,
  J as EmeraldThemeProvider,
  H as LinearLayout,
  q as dontForwardProps,
  g as dontForwardTransientProps,
  A as dotStatusColorMap,
  E as getDotStatus,
  M as lightTheme,
  u as shouldForwardProp
};
